// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_md-0";